import { render, staticRenderFns } from "./AccountSettingTab.vue?vue&type=template&id=396d65f9&"
import script from "./AccountSettingTab.vue?vue&type=script&lang=js&"
export * from "./AccountSettingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports